import { render, staticRenderFns } from "./treasureBox.vue?vue&type=template&id=c1520e22&scoped=true&"
import script from "./treasureBox.vue?vue&type=script&lang=js&"
export * from "./treasureBox.vue?vue&type=script&lang=js&"
import style0 from "./treasureBox.vue?vue&type=style&index=0&id=c1520e22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1520e22",
  null
  
)

export default component.exports